import { isEmpty } from 'lodash-es';
import { connect } from 'react-redux';
import { getTaxAndFeesLabels } from '../../../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import {
  getAddGuestReservationObj,
  getAdults,
  getArrival,
  getBillableGuest,
  getCabanaDeposit,
  getDeparture,
  getDepositPaid,
  getIsDynamicOfferCode,
  getIsPackagesUpdated,
  getKids,
  getNumberOfNights,
  getOffersDiscountApplied,
  getParkingFee,
  getPointsDiscountApplied,
  getPrivateLodgingFee,
  getRateType,
  getResortFee,
  getRoomDeposit,
  getSuiteDetails,
  getSuppressRate,
  getSustainabilityFee,
  getTaxesAndFeesForReservation,
  getTotalBillAndNonBillGuest,
  getTotalRoomRate,
  getCostSummarySuiteName
} from '../../../../../store/componentStores/ManageReservation/manageReservation.selectors';
import {
  getAditionalPackagesFromAddApackage,
  getDueAtCheckinAmountWithAdditionalPackages,
  getSummaryTotalWithAdditionalPackages,
  getTaxesAmountWithAdditionalPackages,
  packagesWithAmountFromReservationData
} from '../../../../../store/reducers';
import { isArrayEmpty } from '../../../../../utilities/arraysUtils';
import { getDateMonthDayFormat } from '../../../../../utilities/dates';
import { getGuestCountLabel } from '../../../../../utilities/guestsUtils';
import { getTaxesAndFees, getTaxesAndFeesDynamic } from '../../../../../utilities/taxes';
import { Summary } from './Summary';

const mapStateToProps = state => {
  const reservationDetails = state.entities.manageReservationDetails;
  const packages = packagesWithAmountFromReservationData(state) ?? [];
  const { offerCode } = getSuiteDetails(reservationDetails);
  const hasPackages = packages && !isArrayEmpty(packages);

  const taxAndFeeLabels = getTaxAndFeesLabels(state.lodgeConfig);

  const taxesAndFeesPrices = getTaxesAndFeesForReservation(reservationDetails);

  const taxesAndFees =
    !isEmpty(taxAndFeeLabels) && !isEmpty(taxesAndFeesPrices)
      ? getTaxesAndFeesDynamic(taxAndFeeLabels, taxesAndFeesPrices)
      : getTaxesAndFees(
        getSustainabilityFee(reservationDetails),
        getTaxesAmountWithAdditionalPackages(state),
        getResortFee(reservationDetails),
        getParkingFee(reservationDetails),
        getPrivateLodgingFee(reservationDetails)
      );

  const addGuestReservation = getAddGuestReservationObj(reservationDetails);

  const voyagerPointsDiscount = getPointsDiscountApplied(reservationDetails);
  const offersPointsDiscount = getOffersDiscountApplied(reservationDetails);
  const hasDiscountCharges = voyagerPointsDiscount || offersPointsDiscount ? true : false;

  return {
    additionalPackages: getAditionalPackagesFromAddApackage(state),
    checkIn: getDateMonthDayFormat(getArrival(reservationDetails)),
    checkOut: getDateMonthDayFormat(getDeparture(reservationDetails)),
    depositPaid: getDepositPaid(reservationDetails),
    dueAtCheckinAmount: getDueAtCheckinAmountWithAdditionalPackages(state),
    guestCountText: getGuestCountLabel(
      addGuestReservation ? addGuestReservation?.guests?.adults : getAdults(reservationDetails),
      addGuestReservation ? addGuestReservation?.guests?.children?.length : getKids(reservationDetails),
      null,
      true
    ),
    addGuestReservation: addGuestReservation,
    hasAdditionalCharges: taxesAndFees && taxesAndFees.length > 0,
    hasSelectedPackages: hasPackages,
    numberOfGuests: getBillableGuest(reservationDetails),
    numberOfNights: getNumberOfNights(reservationDetails),
    packages: packages,
    promoCode: offerCode,
    resortLocation: state.currentLodge,
    suiteTotal: getTotalRoomRate(reservationDetails),
    taxesAndFees: taxesAndFees,
    total: getSummaryTotalWithAdditionalPackages(state),
    suppressRate: getSuppressRate(reservationDetails),
    cabanaDeposit: getCabanaDeposit(reservationDetails),
    roomDeposit: getRoomDeposit(reservationDetails),
    hasDiscountCharges,
    voyagerPointsDiscount,
    offersPointsDiscount,
    totalBillAndNonBillGuest: getTotalBillAndNonBillGuest(reservationDetails),
    rateType: getRateType(reservationDetails),
    isDynamicOfferCode: getIsDynamicOfferCode(reservationDetails),
    isPackagesUpdated: getIsPackagesUpdated(reservationDetails),
    suiteTitle: getCostSummarySuiteName(reservationDetails)
  };
};

const ReservationSummary = connect(mapStateToProps, null)(Summary);

export { ReservationSummary };

